import { render, staticRenderFns } from "./OfferAccreditationBadges.vue?vue&type=template&id=cd6d4f42&scoped=true"
import script from "./OfferAccreditationBadges.vue?vue&type=script&lang=js"
export * from "./OfferAccreditationBadges.vue?vue&type=script&lang=js"
import style0 from "./OfferAccreditationBadges.vue?vue&type=style&index=0&id=cd6d4f42&prod&scoped=true&lang=scss"
import style1 from "./OfferAccreditationBadges.vue?vue&type=style&index=1&id=cd6d4f42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6d4f42",
  null
  
)

export default component.exports